module.exports = __webpack_public_path__ + "img/faq2.e2dfc608.png";